import styles from "./TopBarVerticalDivider.module.scss"

export default function TopBarVerticalDivider() {
    return <div className={styles.base}>/</div>
}
